export const mockData = {
  about: {
    title: "Uplifting Wayanad's Entrepreneurial Spirit",
    description: "We believe that innovation knows no geographical boundaries. Our mission is to transform rural Wayanad into a thriving startup ecosystem, connecting local entrepreneurs with global opportunities and world-class resources.",
    stats: [
      { number: "6", label: "Month Program" },
      { number: "100%", label: "Mentorship Support" },
      { number: "24/7", label: "Community Access" },
      { number: "∞", label: "Growth Potential" }
    ],
    features: [
      {
        title: "Local Roots, Global Reach",
        description: "Leverage Wayanad's unique strengths while accessing international markets and opportunities."
      },
      {
        title: "Community-Driven Growth",
        description: "Build alongside fellow entrepreneurs in a supportive, collaborative environment."
      },
      {
        title: "Sustainable Innovation",
        description: "Create businesses that not only succeed but also give back to the local community."
      }
    ]
  },
  howItWorks: {
    title: "Your Journey to Success",
    subtitle: "A proven 6-month pathway from idea to market-ready startup",
    steps: [
      {
        phase: "Phase 1",
        title: "Idea Screening & Selection",
        duration: "Week 1-2",
        description: "Rigorous evaluation of your startup idea, market potential, and founder-market fit.",
        activities: ["Pitch presentation", "Market analysis", "Founder assessment", "Equity discussion"]
      },
      {
        phase: "Phase 2",
        title: "Intensive In-Person Program",
        duration: "Month 1-3",
        description: "Full-time mentorship at our Wayanad hub with hands-on MVP development and business planning.",
        activities: ["MVP development", "Market fit validation", "Business model design", "Expert mentorship"]
      },
      {
        phase: "Phase 3",
        title: "Virtual Scale & Support",
        duration: "Month 4-6",
        description: "Continued virtual mentorship as you scale your startup with ongoing expert guidance.",
        activities: ["Growth acceleration", "Investor preparation", "Market expansion", "Demo day prep"]
      },
      {
        phase: "Demo Day",
        title: "Investor & Customer Showcase",
        duration: "Month 6",
        description: "Present your startup to potential investors, customers, and industry leaders.",
        activities: ["Pitch refinement", "Investor meetings", "Customer acquisition", "Partnership opportunities"]
      }
    ]
  },
  benefits: {
    title: "Why Choose Modern Innovation Hub?",
    subtitle: "Everything you need to build a successful startup",
    benefits: [
      {
        title: "Expert Mentorship",
        description: "Access to seasoned entrepreneurs, industry experts, and successful founders who've been where you want to go.",
        icon: "👥"
      },
      {
        title: "Free Workspace",
        description: "State-of-the-art co-working space in Wayanad with all amenities included - focus on building, not logistics.",
        icon: "🏢"
      },
      {
        title: "MVP Development Support",
        description: "Technical guidance and resources to build your minimum viable product efficiently and effectively.",
        icon: "🛠️"
      },
      {
        title: "Market Fit Validation",
        description: "Proven methodologies to test and validate your business idea with real customers and market feedback.",
        icon: "📊"
      },
      {
        title: "Business Plan Creation",
        description: "Comprehensive business planning support with financial modeling, strategy development, and growth planning.",
        icon: "📋"
      },
      {
        title: "Investor Access",
        description: "Direct connections to our network of investors, VCs, and angel investors looking for promising startups.",
        icon: "💰"
      },
      {
        title: "Customer Network",
        description: "Access to potential customers, partners, and distribution channels to accelerate your go-to-market strategy.",
        icon: "🤝"
      },
      {
        title: "Ongoing Support",
        description: "Lifetime alumni network and continued mentorship even after program completion.",
        icon: "🌟"
      }
    ]
  },
  testimonials: [
    {
      name: "Arjun Nair",
      company: "EcoFarm Solutions",
      role: "Founder & CEO",
      content: "The Modern Innovation Hub transformed my agricultural tech idea into a thriving business. The mentorship and resources provided were invaluable in helping me navigate the startup journey.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
    },
    {
      name: "Priya Menon",
      company: "Spice Route Digital",
      role: "Co-founder",
      content: "Being part of this program opened doors I never thought possible. From a small idea in Wayanad to serving customers globally - the journey has been incredible.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b402?w=100&h=100&fit=crop&crop=face"
    },
    {
      name: "Ravi Kumar",
      company: "Green Energy Innovations",
      role: "Founder",
      content: "The 6-month program gave me everything I needed - mentorship, workspace, and most importantly, a community of like-minded entrepreneurs. Highly recommended!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face"
    }
  ],
  faq: [
    {
      question: "What is the selection criteria for the program?",
      answer: "We look for passionate founders with innovative ideas, strong commitment, and potential for growth. The selection process includes idea evaluation, founder assessment, and market potential analysis."
    },
    {
      question: "Is this an equity-free program?",
      answer: "No, this is not an equity-free program. We take equity in exchange for the intensive mentorship, resources, and ongoing support we provide. Equity terms are discussed during the selection process."
    },
    {
      question: "Do I need to relocate to Wayanad for the program?",
      answer: "Yes, the first 3 months require you to be physically present at our Wayanad hub for intensive mentorship and collaboration. The remaining 3 months are conducted virtually."
    },
    {
      question: "What stage should my startup be in to apply?",
      answer: "We accept startups at various stages - from early ideas to early-stage companies. What matters most is your commitment, the potential of your idea, and your willingness to learn and grow."
    },
    {
      question: "What happens after the 6-month program?",
      answer: "You'll have access to our demo day for investor and customer connections, plus ongoing support through our alumni network. We continue to provide guidance and connections as you scale."
    },
    {
      question: "Are there any costs associated with the program?",
      answer: "The workspace, mentorship, and most resources are provided free of charge. However, personal expenses and specific business development costs may be your responsibility."
    }
  ]
};